// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false
// };

export const environment = {
  production: false,
  googleClientId: '1092043926679-462pqq528dva23ehbc8ehhs02r30q67n.apps.googleusercontent.com'
};
  //legaldev=="1092043926679-7im5bs52o4rmeu61f11e508ioaskbo78.apps.googleusercontent.com")
  //production--"1092043926679-462pqq528dva23ehbc8ehhs02r30q67n.apps.googleusercontent.com")
  //recovery--1092043926679-4vjqafru0k5bnncqfp6b4qgagsjvt6tm.apps.googleusercontent.com
  //dev--1092043926679-vmr7qahaflvvvc8ru619n354pdhp15bp.apps.googleusercontent.com
  //dev23--1092043926679-ms5svot3h41hs40ddh5dk8a2pmsc91a7.apps.googleusercontent.com